import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect } from 'react';
import classNames from 'classnames';
import { FormGroup, Feedback } from '@availity/form';
import { Label } from 'reactstrap';
import Select from './Select';

var SelectField = function SelectField(_ref) {
  var feedbackClass = _ref.feedbackClass,
      groupClass = _ref.groupClass,
      label = _ref.label,
      labelClass = _ref.labelClass,
      labelHidden = _ref.labelHidden,
      name = _ref.name,
      attributes = _objectWithoutPropertiesLoose(_ref, ["feedbackClass", "groupClass", "label", "labelClass", "labelHidden", "name"]);

  useEffect(function () {
    if (attributes.id && attributes.id === name) {
      console.warn("Warning: Using an 'id' equivalent to 'name' will result in an orphaned label and break 508 compliance.");
    }
  }, [attributes.id, name]);
  var thisLabel = false;

  if (label) {
    thisLabel = React.createElement(Label, {
      "for": name,
      hidden: labelHidden,
      className: labelClass
    }, label);
  }

  return React.createElement(FormGroup, {
    className: groupClass,
    "for": name,
    disabled: attributes.disabled
  }, thisLabel, React.createElement(Select, Object.assign({
    name: name
  }, attributes)), React.createElement(Feedback, {
    className: classNames('d-block', feedbackClass),
    name: name
  }));
};

export default SelectField;